var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2039 6.66671C21.5063 6.92079 22.7031 7.55772 23.6414 8.49595C24.5796 9.43419 25.2165 10.6311 25.4706 11.9334L20.2039 6.66671ZM20.2039 1.33337C22.9096 1.63396 25.4327 2.84561 27.3589 4.76938C29.2851 6.69316 30.5 9.21472 30.8039 11.92L20.2039 1.33337ZM29.4706 22.56V26.56C29.4721 26.9314 29.3961 27.2989 29.2473 27.6392C29.0985 27.9794 28.8803 28.2848 28.6067 28.5359C28.3331 28.7869 28.01 28.978 27.6583 29.097C27.3065 29.2159 26.9338 29.2601 26.5639 29.2267C22.4611 28.7809 18.5199 27.3789 15.0573 25.1334C11.8357 23.0863 9.1044 20.3549 7.05728 17.1334C4.80392 13.655 3.4016 9.6947 2.96395 5.57337C2.93063 5.20466 2.97445 4.83305 3.09261 4.48221C3.21078 4.13136 3.40071 3.80896 3.6503 3.53554C3.8999 3.26211 4.20369 3.04365 4.54234 2.89407C4.88098 2.74449 5.24707 2.66706 5.61728 2.66671H9.61728C10.2644 2.66034 10.8917 2.88948 11.3823 3.31142C11.8729 3.73336 12.1934 4.3193 12.2839 4.96004C12.4528 6.24013 12.7659 7.49701 13.2173 8.70671C13.3967 9.18394 13.4355 9.70259 13.3292 10.2012C13.2228 10.6998 12.9758 11.1575 12.6173 11.52L10.9239 13.2134C12.822 16.5514 15.5859 19.3153 18.9239 21.2134L20.6173 19.52C20.9798 19.1616 21.4375 18.9145 21.9361 18.8082C22.4347 18.7018 22.9534 18.7406 23.4306 18.92C24.6403 19.3714 25.8972 19.6845 27.1773 19.8534C27.825 19.9447 28.4165 20.271 28.8393 20.77C29.2622 21.2691 29.4868 21.9061 29.4706 22.56Z",
    stroke: "#333333",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.137268)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.95d975aa6b70d600eb148f76780a6d6b.svg";
export { ForwardRef as ReactComponent };